// extracted by mini-css-extract-plugin
module.exports = {"tag":"Bookmark_tag__3SHb9"};